import { c as _c } from "react/compiler-runtime";
import { getWsConnectionState, subscribeWsConnectionState, type WsConnectionState } from '@src/lib/wsConnectionStatus';
import { useEffect, useState } from 'react';

/**
 * React subscription to the GraphQL WebSocket transport status.
 * Status is driven by graphql-ws client lifecycle (not a GraphQL payload).
 */
export function useWsConnectionStatus() {
  const $ = _c(2);
  const [state, setState] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setState(getWsConnectionState());
      return subscribeWsConnectionState(setState);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return state;
}
function _temp() {
  return getWsConnectionState();
}